import RootLoader from './root-loader';

export default RootLoader;
